(function (window) {
  const SurePopup = (function () {
    let popup = null;
    let currentConfig = null;

    function createPopup() {
      popup = document.querySelector(".sure-popup");
      if (!popup) return null;

      popup.classList.add("sure-popup_active");

      const windowCover = popup.querySelector(".window-cover");
      const closeBtn = popup.querySelector(".icon-Close");
      const btnLeft = popup.querySelector(".sure_popup-btn-left");
      const btnRight = popup.querySelector(".sure_popup-btn-right");
      const main = popup.querySelector(".sure-popup-main");

      /* ========= 统一事件绑定 ========= */

      // 点击遮罩关闭
      windowCover?.addEventListener("click", close);

      // 右上角关闭
      closeBtn?.addEventListener("click", close);

      // 取消按钮
      btnRight?.addEventListener("click", function () {
        currentConfig?.onCancel?.();
        close();
      });

      // 确认按钮
      btnLeft?.addEventListener("click", function () {
        currentConfig?.onConfirm?.();
        close();
      });

      // 阻止内部点击关闭
      main?.addEventListener("click", function (e) {
        e.stopPropagation();
      });

      return popup;
    }
    function open(config = {}) {
      if (!popup) popup = createPopup();
      if (!popup) return;

      currentConfig = config;

      const {
        title = "sorry",
        text = "Are you sure?",
        leftText = "Yes",
        rightText = "No",
        zIndex = 180,
        lockScroll = true,
        showClose = true,
        showMask = true,
      } = config;

      /* 文案 */

      // 标题使用 textContent
      const titleEl = popup.querySelector(".pop_title span");
      if (titleEl) {
        titleEl.textContent = title;
      }

      // 正文使用 innerHTML 以支持 HTML 标签
      const mainWordEl = popup.querySelector(".sure-popup-main-word");
      if (mainWordEl) {
        mainWordEl.innerHTML = text;
      }

      // 按钮文本使用 textContent
      const btnLeft = popup.querySelector(".sure_popup-btn-left");
      const btnRight = popup.querySelector(".sure_popup-btn-right");
      if (btnLeft) btnLeft.textContent = leftText;
      if (btnRight) btnRight.textContent = rightText;

      /* 显示 */

      popup.classList.remove("none");

      const windowCover = popup.querySelector(".window-cover");

      windowCover.style.display = showMask ? "block" : "none";

      /* 层级 */

      popup.querySelector(".sure-popup-main").style.zIndex = zIndex;
      windowCover.style.zIndex = zIndex - 1;

      /* 关闭按钮 */

      const closeBtn = popup.querySelector(".icon-Close");
      closeBtn.style.display = showClose ? "block" : "none";

      /* 滚动锁定 */

      if (lockScroll) {
        document.body.style.overflow = "hidden";
      }
    }
    // function open(config = {}) {
    //   if (!popup) popup = createPopup();
    //   if (!popup) return;

    //   currentConfig = config;

    //   const {
    //     title = "sorry",
    //     text = "Are you sure?",
    //     leftText = "Yes",
    //     rightText = "No",
    //     zIndex = 180,
    //     lockScroll = true,
    //     showClose = true,
    //     showMask = true,
    //   } = config;

    //   /* 文案 */

    //   popup.querySelector(".pop_title span").textContent = title;
    //   popup.querySelector(".sure-popup-main-word").textContent = text;
    //   popup.querySelector(".sure_popup-btn-left").textContent = leftText;
    //   popup.querySelector(".sure_popup-btn-right").textContent = rightText;

    //   /* 显示 */

    //   popup.classList.remove("none");

    //   const windowCover = popup.querySelector(".window-cover");

    //   windowCover.style.display = showMask ? "block" : "none";

    //   /* 层级 */

    //   popup.querySelector(".sure-popup-main").style.zIndex = zIndex;
    //   windowCover.style.zIndex = zIndex - 1;

    //   /* 关闭按钮 */

    //   const closeBtn = popup.querySelector(".icon-Close");
    //   closeBtn.style.display = showClose ? "block" : "none";

    //   /* 滚动锁定 */

    //   if (lockScroll) {
    //     document.body.style.overflow = "hidden";
    //   }
    // }

    function close() {
      if (!popup) return;

      popup.classList.add("none");

      document.body.style.overflow = "";

      currentConfig = null;
    }

    return { open, close };
  })();

  window.SurePopup = SurePopup;
})(window);
